import React from "react";
import { HomeworkEngagement } from "../api/contracts";

function formatEngagementRate(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

function MetricCard({
  label,
  value,
  note,
}: {
  label: string;
  value: number;
  note: string;
}) {
  return (
    <div className="cp-metric-card">
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{note}</small>
    </div>
  );
}

export function CompletionDonut({
  engagementRate,
  homeworkCompleted,
  totalAssigned,
}: HomeworkEngagement) {
  const visualRate = Math.min(100, Math.max(0, engagementRate * 100));
  return (
    <div
      className="cp-completion-donut"
      style={{
        backgroundImage: `conic-gradient(var(--cp-chart-completed) ${visualRate * 3.6}deg, var(--cp-chart-remaining) 0deg)`,
      }}
      role="img"
      aria-label={`Homework engagement rate ${formatEngagementRate(engagementRate)}; ${homeworkCompleted} of ${totalAssigned} assignments completed`}
    >
      <div className="cp-completion-donut__center">
        <strong>{formatEngagementRate(engagementRate)}</strong>
        <span>
          {homeworkCompleted} of {totalAssigned} assignments
          <br />
          completed
        </span>
      </div>
    </div>
  );
}

export function HomeworkEngagementSummary({
  engagementRate,
  homeworkCompleted,
  totalAssigned,
}: HomeworkEngagement) {
  const remaining = Math.max(0, totalAssigned - homeworkCompleted);
  return (
    <section
      className="cp-engagement-section"
      aria-labelledby="homework-engagement-title"
    >
      <h2 id="homework-engagement-title">Homework Engagement</h2>
      <div className="cp-engagement-grid">
        <div className="cp-completion-card">
          <h3>Completion Rate</h3>
          <CompletionDonut
            engagementRate={engagementRate}
            homeworkCompleted={homeworkCompleted}
            totalAssigned={totalAssigned}
          />
          <div className="cp-chart-legend" aria-label="Homework totals">
            <span data-series="completed">Completed {homeworkCompleted}</span>
            <span data-series="remaining">Remaining {remaining}</span>
          </div>
        </div>
        <div className="cp-metric-grid">
          <MetricCard
            label="Homework Completed"
            value={homeworkCompleted}
            note="Includes completed with modification"
          />
          <MetricCard
            label="Total Assigned"
            value={totalAssigned}
            note={`Not yet completed: ${remaining}`}
          />
        </div>
      </div>
    </section>
  );
}
